import request from '@/utils/request'

const url = '/home/links/'
const api = {
  getlinks (data) {
    return request({
      url: url + 'getlinks',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/links.js